export default __webpack_public_path__ + "static/media/masaya.a49c5177.webp";